import React from "react";
import CommonUtil from "utils/CommonUtil";
import UIUtil from "utils/UIUtils";

export interface EsignConfirmResult {
    signedData?: string;
    vidRandom?: string;
    result: boolean;
}

/**
 * 사용자 RestRepository
 */
const userRestRepository = new (class UserRestRepository {
    /**
     * CSRF 토큰 조회
     */
    public async readToken(): Promise<any> {
        return await CommonUtil.execute(
            {
                url: "com_token"
            })
            .then((response: any) => {
                return response.TOKEN;
            })
            .catch((error) => {
                CommonUtil.showAxiosError(error);
            });
    }

    /**
     * 사용자 조회
     */
    public async readUser(): Promise<any> {
        return await CommonUtil.execute(
            {
                url: "readUser"
            })
            .then((response: any) => {
                return {
                    ...response
                };
            })
            .catch((error) => {
                CommonUtil.showAxiosError(error);
            });
    }

    /**
     * 세션 조회
     */
    public async readSession(): Promise<{
        checkServerTime: Date;
        creationTime: Date;
        maxInactiveInterval: any;
        remainTime: any;
    } | void> {
        return CommonUtil.execute({
            url: "readSession",
            headers: {"X-Read-Session": true}
        })
            .then(({MODEL}: any) => {
                return {
                    checkServerTime: new Date(MODEL?.checkServerTime),
                    creationTime: new Date(MODEL?.creationTime),
                    maxInactiveInterval: MODEL?.maxInactiveInterval,
                    remainTime: MODEL?.remainTime
                };
            })
            .catch((error) => {
                CommonUtil.showAxiosError(error);
            });
    }

    /**
     * 로그인 정보 수정
     *
     * @param model
     */
    public async putLoginInfo(model: any): Promise<boolean> {
        return await
            CommonUtil.execute({
                url: "loginInfo",
                data: model
            })
                .then((response) => {
                    return true;
                })
                .catch((error) => {
                    CommonUtil.showAxiosError(error);
                    return false;
                })
    }

    /**
     * Delfino 인증
     *
     * @param signedData
     * @param vidRandom
     * @param idn
     */
    public certify(signData?: string):Promise<EsignConfirmResult> {
        return new Promise(resolve => {
            const signCallback = (result: {
                status: number;
                message?: string;
                signData?: string;
                vidRandom?: string;
                certStore?: string; // "LOCAL_DISK:"
                certExpireDate?: string; // "2024-07-10 23:59:59"
            }) => {
                // 전자서명 생성시
                if (result.status === 1) {
                    return CommonUtil.execute({
                        url: "com_certify",
                        data: {
                            SIGNED_DATA: result.signData,
                            VID_RANDOM: result.vidRandom
                        }
                    })
                        .then((response: any) => {
                            console.log("certify response", response);
                            resolve({
                                signedData: result.signData,
                                vidRandom: result.vidRandom,
                                result: response.RESULT
                            });
                        })
                        .catch(error => {
                            CommonUtil.showAxiosError(error);
                            resolve({
                                result: false
                            });
                        });
                } else {
                    if (result.message == "cancel") {
                        UIUtil.alert(`전자서명을 취소하였습니다.`).then(() => {
                            resolve({
                                result: false
                            });
                        });
                    } else {
                        UIUtil.alert(`전자서명 생성시 오류가 발생하였습니다.(${result.message})`).then(() => {
                            resolve({
                                result: false
                            });
                        });
                    }
                }
            }

            window['Delfino'].login(signData||'login', {addNonce:true}, signCallback)
        })
    }

    /**
     * 본인 인증 호출값 조회
     */
    public async getKmcisCert(urlCodeType: string): Promise<string> {
        return await CommonUtil.execute({
            url: "getKmcisCert",
            data: {
                URL_CODE_TYPE: urlCodeType
            }
        })
            .then((response: any) => {
                return response.TR_CERT;
            })
            .catch((error) => {
                CommonUtil.showAxiosError(error);
                return false;
            });
    }
})();

export default userRestRepository;
